import { Controller } from "stimulus"

// Hace polling del progreso del cotejo masivo con Gemini (BulkReconcileInvoicesJob)
// y actualiza la barra de progreso. Cuando termina, recarga para reflejar los
// nuevos estados de validación de las facturas.
export default class extends Controller {
  static values = {
    url: String,
    interval: { type: Number, default: 4000 }
  }
  static targets = ["panel", "bar", "label"]

  connect() {
    this.poll()
  }

  disconnect() {
    this.stop()
  }

  poll() {
    this.timer = setTimeout(() => this.check(), this.intervalValue)
  }

  check() {
    fetch(this.urlValue, { headers: { Accept: "application/json" } })
      .then((r) => (r.ok ? r.json() : Promise.reject(r)))
      .then((data) => this.render(data))
      .catch(() => this.poll())
  }

  render(data) {
    if (!data || data.status === "idle") {
      if (this.hasPanelTarget) this.panelTarget.classList.add("d-none")
      return
    }

    if (this.hasPanelTarget) this.panelTarget.classList.remove("d-none")

    const total = data.total || 0
    const processed = data.processed || 0
    const pct = total > 0 ? Math.round((processed / total) * 100) : 0

    if (this.hasBarTarget) {
      this.barTarget.style.width = `${pct}%`
      this.barTarget.textContent = `${pct}%`
    }
    if (this.hasLabelTarget) {
      this.labelTarget.textContent =
        `${processed}/${total} · ✓ auto-validadas: ${data.validated || 0} · ⚠ a revisar: ${data.pending || 0} · errores: ${data.failed || 0}`
    }

    if (data.status === "running") {
      this.poll()
    } else {
      // done / error → recargar para ver los estados actualizados
      window.location.reload()
    }
  }

  stop() {
    if (this.timer) {
      clearTimeout(this.timer)
      this.timer = null
    }
  }
}
